
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kids-teens-coding-camps/xoxoday",
      function () {
        return require("private-next-pages/kids-teens-coding-camps/xoxoday.tsx");
      }
    ]);
  